import * as DownloadJS from 'downloadjs';
import html2canvas from 'html2canvas';

const imagesToGenerate = document.querySelectorAll('#source-content-grid [data-sharable-view]'),
    $container = document.getElementById( 'share-content-grid' ); // Track items
let imagesProcessed = 0;

async function generateImage(element) {
    try {
        const canvas = await html2canvas(element, {
            backgroundColor: null,
            useCORS: true,
            allowTaint: true,
            scale: 1
        });
        return canvas.toDataURL('image/jpeg', 0.9 );
    } catch (error) {
        console.error('Error generating image:', error);
    }
}


async function initializeShareCard(cardElement) {
    const cardId = cardElement.getAttribute('data-sharable-view');
    const $target = document.querySelector(`#share-content-grid [data-sharable-view="${cardId}"]`);
    const $downloadButton = $target.querySelector('button.download-image');

    try {
        const dataUrl = await generateImage(cardElement);

        const img = document.createElement('img');
        img.src = dataUrl;
        img.alt = '';
        $target.querySelector('figure').appendChild(img);

        imagesProcessed++;

        // If this is the last image, set a class or trigger an event
        if (imagesProcessed === imagesToGenerate.length) {
            $container.classList.add('images-loaded');
            // console.log('✅ All generated images have been added!');
        }

        // Attach download event
        $downloadButton.addEventListener('click', (event) => {
            event.preventDefault();
            DownloadJS(dataUrl, `warframe2024-snapshot-${cardId}.jpg`, 'image/jpeg');
        });
    } catch (error) {
        console.error(`Failed to generate image for ${cardId}:`, error);
        $container.classList.add('loading-error');
    }
}

// Initialize all share cards
function initShareCards() {
    // console.log( 'initShareCards', { imagesToGenerate } );
    imagesToGenerate.forEach((card) => initializeShareCard(card));
}

// Run when the DOM is ready
// Check if `window.onload` has already fired

if (document.readyState === "complete") {
    initShareCards(); // Page is already fully loaded, run immediately
} else {
    window.onload = initShareCards; // Otherwise, wait for `window.onload`
}
